// Slider item butonları. Liste için ayrı endpoint yoktur; butonlar item show
// yanıtındaki `buttons` dizisinden okunur. Burada yalnızca create/put/delete/show var.

const state = () => ({})

const getters = {}

const actions = {
    // show record
    async show(_, {id}) {
        const response = await this._vm.axios.get(this._vm.endpoint.get('module_slider_item_button') + '/' + id)
        return response.data.data
    },

    // add record
    async create(_, {data}) {
        const payload = {...data.data, ...data.translate}
        const response = await this._vm.axios.post(this._vm.endpoint.get('module_slider_item_button'), payload)
        return response.data
    },

    // update record
    async put(_, {id, data}) {
        const payload = {...data.data, ...data.translate}
        const response = await this._vm.axios.put(this._vm.endpoint.get('module_slider_item_button') + '/' + id, payload)
        return response.data
    },

    // delete record
    async delete(_, {id}) {
        const {data} = await this._vm.axios.delete(this._vm.endpoint.get('module_slider_item_button') + '/' + id)
        if (data.status) {
            this._vm.$message.success(this._vm.$t('messages.deleteOk'))
        } else {
            this._vm.$message.error(data.message)
        }
        return data
    },
}

const mutations = {}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
